var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from "classnames";
import * as React from "react";
import { offsetFrom } from "briefscript";
import Icon from "../icon";
const rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
const isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === "string";
}
// Insert one space between two chinese characters automatically.
function insertSpace(child) {
    if (isString(child.type) && isTwoCNChar(child.props.children)) {
        return React.cloneElement(child, {}, child.props.children.split("").join(" "));
    }
    if (isString(child)) {
        if (isTwoCNChar(child)) {
            child = child.split("").join(" ");
        }
        return <span>{child}</span>;
    }
    return child;
}
class Button extends React.Component {
    constructor(props) {
        super(props);
        this.time = 0;
        this.center = { x: 0, y: 0 };
        this.rectangle = {
            x: 0,
            y: 0,
            w: 25,
            h: 25,
        };
        this.buttonRef = React.createRef();
        this.state = { active: false };
    }
    clearTimer() {
        this.timer && clearTimeout(this.timer);
        this.timer = undefined;
    }
    onCancel() {
        this.clearTimer();
        this.state.active && this.onActive(false);
    }
    onActive(act) {
        act != this.state.active && this.setState({ active: act });
    }
    onThrough(e) {
        this.props.stopPropagation && e.stopPropagation();
        if (e.type === "touchstart" || e.type === "touchend") {
            this.props.preventDefault && e.preventDefault();
        }
        return !this.props.disabled;
    }
    touchStart(e) {
        if (this.buttonRef.current != null) {
            const point = offsetFrom(this.buttonRef.current);
            this.rectangle = {
                x: point.x,
                y: point.y,
                w: this.buttonRef.current.offsetWidth,
                h: this.buttonRef.current.offsetHeight,
            };
        }
        else {
            this.rectangle = { x: 0, y: 0, w: 25, h: 25 };
        }
        this.center =
            e.changedTouches !== undefined && e.changedTouches.length > 0
                ? { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY }
                : { x: 0, y: 0 };
        this.time = Date.now();
        if (this.props.onPress != null && this.timer === undefined) {
            this.timer = setTimeout(() => {
                this.props.onPress != null && this.props.onPress({ x: this.center.x, y: this.center.y });
            }, this.props.threshold);
        }
        this.onActive(true);
    }
    touchEnd() {
        this.clearTimer();
        if (this.props.onClick != null && this.state.active) {
            this.props.onClick({ x: this.center.x, y: this.center.y });
        }
        this.onActive(false);
    }
    componentWillUnmount() {
        this.clearTimer();
    }
    render() {
        const _a = this.props, { children, className, prefixCls, type, inline, disabled, icon, loading, activeStyle, activeClassName, threshold, stopPropagation, preventDefault, onClick, onPress } = _a, restProps = __rest(_a, ["children", "className", "prefixCls", "type", "inline", "disabled", "icon", "loading", "activeStyle", "activeClassName", "threshold", "stopPropagation", "preventDefault", "onClick", "onPress"]);
        const iconType = loading ? "loading" : icon;
        const wrapCls = classnames(prefixCls, className, {
            [`${prefixCls}-primary`]: type === "primary",
            [`${prefixCls}-ghost`]: type === "ghost",
            [`${prefixCls}-warning`]: type === "warning",
            [`${prefixCls}-inline`]: inline,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-loading`]: loading,
            [`${prefixCls}-icon`]: !!iconType,
        });
        const activeRealClassName = activeClassName || (activeStyle ? `${prefixCls}-active` : undefined);
        const kids = React.Children.map(children, insertSpace);
        let iconEl;
        if (typeof iconType === "string") {
            iconEl = <Icon aria-hidden="true" type={iconType} className={`${prefixCls}-icon`}/>;
        }
        else if (iconType) {
            const rawCls = iconType.props && iconType.props.className;
            const cls = classnames("pm-icon", `${prefixCls}-icon`);
            iconEl = React.cloneElement(iconType, {
                className: rawCls ? `${rawCls} ${cls}` : cls,
            });
        }
        return (<a role="button" ref={this.buttonRef} className={`${wrapCls} ${this.state.active ? activeRealClassName : undefined}`} aria-disabled={disabled} onTouchStart={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.touchStart(e);
        }} onTouchMove={e => {
            if (!this.onThrough(e)) {
                return;
            }
            if (!this.state.active) {
                return;
            }
            if (e.changedTouches[0].pageX <= this.rectangle.x ||
                e.changedTouches[0].pageX >= this.rectangle.x + this.rectangle.w ||
                e.changedTouches[0].pageY <= this.rectangle.y ||
                e.changedTouches[0].pageY >= this.rectangle.y + this.rectangle.h) {
                this.onCancel();
            }
        }} onTouchEnd={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.touchEnd();
        }} onTouchCancel={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.onCancel();
        }} onMouseDown={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.touchStart(e);
        }} onMouseUp={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.touchEnd();
        }} onMouseLeave={e => {
            if (!this.onThrough(e)) {
                return;
            }
            this.onCancel();
        }} {...restProps}>
        {iconEl}
        {kids}
      </a>);
    }
}
Button.defaultProps = {
    prefixCls: "pm-button",
    inline: false,
    disabled: false,
    loading: false,
    threshold: 251,
    preventDefault: true,
    stopPropagation: true,
    activeStyle: {},
};
export default Button;
